<template>
  <div>
    <!-- Top Bar -->
    <div class="top-bar">
      <div class="ortala">
        <div style="margin-top: 20px; margin-bottom: 20px">
          <p>
            Ayyıldız Mobilya'ya Hoşgeldiniz!
            <i
              style="margin-left: 50px; color: rgb(0, 255, 0)"
              class="fab fa-whatsapp"
            ></i>
            <a
              target="_blank"
              :href="'https://api.whatsapp.com/send/?phone=905422233996'"
              class="whatsapp"
              >Tel: 0(542) 223 39 96</a
            >
          </p>
        </div>
      </div>
    </div>

    <!-- Header -->
    <div class="header">
      <div class="ortala header-content">
        <div class="logo">
          <router-link to="/"
            ><img src="@/assets/img/ayyildizLogo.png" alt="Logo"
          /></router-link>
        </div>
        <!-- Hamburger Icon -->
        <div class="hamburger" @click="toggleMenu">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <!-- Menu -->
        <div class="menu" :class="{ 'menu-active': menuOpen }">
          <div
            v-if="menuOpen"
            @click="toggleMenu"
            class="close"
            :class="{ 'menu-active': menuOpen }"
          >
            GERİ >
          </div>
          <ul>
            <router-link style="text-decoration: none; color: black" to="/">
              <li>Ana Sayfa</li></router-link
            >
            <router-link
              style="text-decoration: none; color: black"
              to="/projeler"
            >
              <li>Projeler</li></router-link
            ><router-link
              style="text-decoration: none; color: black"
              to="/iletisim"
            >
              <li>İletişim</li></router-link
            >
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  data() {
    return {
      menuOpen: false, // Menü açık mı kapalı mı kontrolü
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen; // Menü durumunu değiştir
    },
  },
};
</script>

<style>
/* Top Bar */
.top-bar {
  background-color: #e5e5e5;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
}
.top-bar p {
  margin: 0;
}
.top-bar .whatsapp {
  text-decoration: none;
  color: black;
  margin-left: 5px;
  transition: 0.2s ease-in-out;
}
.top-bar .whatsapp:hover {
  color: orange;
}

/* Header */
.header {
  background-color: #eee;
  width: 100%;
  position: relative;
  z-index: 10;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap; /* Logonun altına düşmesini engeller */
}

/* Logo */
.logo img {
  width: 150px;
  height: auto;
}

/* Hamburger Menu */
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 25px;
  height: 20px;
  cursor: pointer;
}
.hamburger div {
  height: 3px;
  background-color: black;
  border-radius: 2px;
}

/* Menü */
.menu {
  display: flex;
  align-items: center;
}
.menu ul {
  list-style: none;
  display: flex;
  gap: 40px;
  margin: 0;
  padding: 0;
}
.menu ul li {
  font-size: 20px;
  transition: 0.2s ease-in-out;
}
.menu ul li:hover {
  color: orange;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .top-bar {
    width: auto;
  }
  .top-bar p {
    display: flex;
  }

  .hamburger {
    display: flex;
  }

  .menu {
    position: fixed;
    top: 0;
    right: 0;
    background-color: #eee; /* Koyu ve saydam bir arka plan */
    width: 250px;
    height: 100vh;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 20px 0;
    box-shadow: -4px 0 8px rgba(0, 0, 0, 0.2);
  }
  .menu ul {
    flex-direction: column;
    gap: 30px; /* Menü öğeleri arasına daha fazla boşluk ekledim */
  }
  .menu-active {
    transform: translateX(0); /* Menü sağdan düzgünce açılır */
  }

  /* Kapatma Butonu */
  .menu .close {
    font-weight: bold;
    font-size: 30px;
    color: black;
    background-color: transparent;
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 20px;
    cursor: pointer;
    transition: 0.2s ease-in-out;
  }
  .menu .close:hover {
    color: orange;
  }

  /* Menü öğeleri */
  .menu ul li {
    font-size: 20px; /* Menü öğelerini daha büyük yaparak modernleştiriyorum */
    font-weight: bold;
    color: black;
    transition: color 0.3s ease-in-out;
    margin: 0 auto;
  }
  .menu ul li:hover {
    color: orange; /* Hoverda rengin değişmesini sağlıyoruz */
  }

  .logo {
    flex-grow: 1;
    text-align: left;
  }
}
</style>
